(function () {
  if (window.__tokenGateInitialized) return;
  window.__tokenGateInitialized = true;

  var TOKEN_ATTRIBUTE = "_gate_token";
  var VERIFIED_ATTRIBUTE = "_gate_verified";
  var VERIFY_TTL_MS = 30 * 60 * 1000;
  var CART_MESSAGE_ID = "token-gate-cart-message";
  var WALLET_SESSION_KEY = "_token_gate_wallet_session";

  function parseJSON(value, fallback) {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (_err) {
      return fallback;
    }
  }

  function getStoredWalletSession() {
    try {
      return parseJSON(window.localStorage.getItem(WALLET_SESSION_KEY), null);
    } catch (_err) {
      return null;
    }
  }

  function saveWalletSession(walletAddress) {
    if (!walletAddress) return;
    try {
      window.localStorage.setItem(
        WALLET_SESSION_KEY,
        JSON.stringify({
          walletAddress: String(walletAddress).toLowerCase(),
          savedAt: Date.now(),
        })
      );
    } catch (_err) {
      // Ignore storage failures.
    }
  }

  function toVariantGid(id) {
    if (!id) return "";
    return String(id).indexOf("gid://") === 0
      ? String(id)
      : "gid://shopify/ProductVariant/" + String(id);
  }

  function getProductContainer() {
    return document.getElementById("token-gate-container");
  }

  function getResultElement() {
    return document.getElementById("token-gate-result");
  }

  function getProductForm() {
    var container = getProductContainer();
    if (container) {
      return container.closest('form[action="/cart/add"]');
    }
    return document.querySelector('.product-page form[action="/cart/add"]');
  }

  function getAddButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '.product-page form[action="/cart/add"] button[type="submit"], ' +
          '.product-page form[action="/cart/add"] [name="add"], ' +
          '.product-page .product-page__add-btn'
      )
    );
  }

  function getCheckoutButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        'button[name="checkout"], .cart-checkout-btn, [formaction="/checkout"], a[href="/checkout"]'
      )
    );
  }

  function getSelectedVariantId() {
    var select = document.getElementById("variant-select");
    if (select && select.value) return toVariantGid(select.value);

    var input = document.querySelector('form[action="/cart/add"] [name="id"]');
    return input && input.value ? toVariantGid(input.value) : "";
  }

  function getGatedVariants(container) {
    var variants = parseJSON(container.dataset.gatedVariants, []);
    return Array.isArray(variants) ? variants : [];
  }

  function isCurrentSelectionGated(container) {
    if (!container || !container.dataset.gateRuleHandle) return false;

    var gatedVariants = getGatedVariants(container);
    if (!gatedVariants.length) return true;

    var selectedVariantId = getSelectedVariantId();
    return selectedVariantId ? gatedVariants.indexOf(selectedVariantId) !== -1 : false;
  }

  function normalizeVerifiedState(state) {
    var nextState = state && typeof state === "object" ? state : {};
    if (!nextState.products || typeof nextState.products !== "object") {
      nextState.products = {};
    }

    var now = Date.now();
    Object.keys(nextState.products).forEach(function (productId) {
      var entry = nextState.products[productId];
      if (!entry || !entry.expiresAt || entry.expiresAt < now) {
        delete nextState.products[productId];
      }
    });

    return nextState;
  }

  async function fetchCart() {
    var response = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    return response.json();
  }

  async function persistVerifiedState(gateToken) {
    var container = getProductContainer();
    if (!container) return normalizeVerifiedState({});

    var cart = await fetchCart();
    var attributes = Object.assign({}, cart.attributes || {});
    var verifiedState = normalizeVerifiedState(parseJSON(attributes[VERIFIED_ATTRIBUTE], {}));
    var productId = container.dataset.productId;
    var gatedVariants = getGatedVariants(container);
    var selectedVariantId = getSelectedVariantId();
    var now = Date.now();

    verifiedState.products[productId] = {
      gateRuleHandle: container.dataset.gateRuleHandle,
      verifiedAt: now,
      expiresAt: now + VERIFY_TTL_MS,
      variantIds:
        gatedVariants.length && selectedVariantId ? [selectedVariantId] : [],
    };

    attributes[TOKEN_ATTRIBUTE] = gateToken;
    attributes[VERIFIED_ATTRIBUTE] = JSON.stringify(verifiedState);

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attributes }),
    });

    return verifiedState;
  }

  function isSelectionVerified(verifiedState, container) {
    if (!container || !container.dataset.productId) return true;
    if (!isCurrentSelectionGated(container)) return true;

    var entry = verifiedState.products[container.dataset.productId];
    if (!entry) return false;

    if (!entry.variantIds || !entry.variantIds.length) return true;

    var selectedVariantId = getSelectedVariantId();
    return entry.variantIds.indexOf(selectedVariantId) !== -1;
  }

  function updateAddToCartState(blocked) {
    var form = getProductForm();
    if (form) {
      form.dataset.tokenGateBlocked = blocked ? "true" : "false";
    }

    getAddButtons().forEach(function (button) {
      var originalText =
        button.dataset.originalLabel || button.textContent || "Add to Cart";
      if (!button.dataset.originalLabel) {
        button.dataset.originalLabel = originalText;
      }

      if (blocked) {
        button.disabled = true;
        button.textContent = "Verify Wallet to Continue";
      } else {
        var select = document.getElementById("variant-select");
        var selectedOption =
          select && select.options && select.selectedIndex >= 0
            ? select.options[select.selectedIndex]
            : null;

        button.disabled = !!(selectedOption && selectedOption.disabled);
        button.textContent =
          selectedOption && selectedOption.disabled ? "Sold Out" : originalText;
      }
    });
  }

  function showCartButtons() {
    var hideStyle = document.getElementById("token-gate-hide-cart");
    if (hideStyle) hideStyle.remove();
    updateAddToCartState(false);
  }

  function showResult(msg, type) {
    var result = getResultElement();
    if (!result) return;

    result.style.display = "block";
    result.style.padding = "12px";
    result.style.borderRadius = "6px";
    result.style.fontSize = "14px";

    if (type === "success") {
      result.style.background = "#f0fdf4";
      result.style.border = "1px solid #bbf7d0";
      result.style.color = "#166534";
    } else if (type === "info") {
      result.style.background = "#f0f9ff";
      result.style.border = "1px solid #bae6fd";
      result.style.color = "#0c4a6e";
    } else {
      result.style.background = "#fef2f2";
      result.style.border = "1px solid #fecaca";
      result.style.color = "#991b1b";
    }

    result.textContent = msg;
  }

  function updateProductGateState(verifiedState) {
    var container = getProductContainer();
    if (!container) return;

    if (!isCurrentSelectionGated(container)) {
      showCartButtons();
      return;
    }

    if (isSelectionVerified(verifiedState, container)) {
      showCartButtons();
      return;
    }

    updateAddToCartState(true);
    showResult(
      "Verify your wallet before adding this gated item to cart.",
      "info"
    );
  }

  function shortenAddress(addr) {
    return addr.slice(0, 6) + "\u2026" + addr.slice(-4);
  }

  function resetWalletList() {
    var walletListEl = document.getElementById("token-gate-wallet-list");
    var connectBtn = document.getElementById("token-gate-connect-btn");
    if (walletListEl) {
      walletListEl.innerHTML = "";
      walletListEl.style.display = "none";
    }
    if (connectBtn) {
      connectBtn.disabled = false;
      connectBtn.textContent = "Connect Wallet";
      connectBtn.style.display = "inline-block";
    }
  }

  function isUsableProvider(provider) {
    return !!provider && typeof provider.request === "function";
  }

  function getAvailableProviders(discoveredWallets) {
    var providers = [];

    discoveredWallets.forEach(function (wallet) {
      if (!wallet || !isUsableProvider(wallet.provider)) return;
      var duplicate = providers.some(function (entry) {
        return entry.provider === wallet.provider;
      });
      if (!duplicate) {
        providers.push({
          provider: wallet.provider,
          name: wallet.info && wallet.info.name ? wallet.info.name : "Wallet",
        });
      }
    });

    if (isUsableProvider(window.ethereum)) {
      var hasBrowserWallet = providers.some(function (entry) {
        return entry.provider === window.ethereum;
      });
      if (!hasBrowserWallet) {
        providers.unshift({
          provider: window.ethereum,
          name: "Wallet",
        });
      }
    }

    return providers;
  }

  async function connectWithProvider(provider, walletName) {
    var container = getProductContainer();
    var walletListEl = document.getElementById("token-gate-wallet-list");
    var connectBtn = document.getElementById("token-gate-connect-btn");

    if (!container) return;

    if (walletListEl) walletListEl.style.display = "none";
    if (connectBtn) {
      connectBtn.disabled = true;
      connectBtn.textContent = "Connecting...";
    }
    showResult("Connecting to " + walletName + "\u2026", "info");

    try {
      var accounts = await provider.request({ method: "eth_requestAccounts" });
      var walletAddress = accounts[0];
      if (!walletAddress && provider !== window.ethereum && isUsableProvider(window.ethereum)) {
        accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
        walletAddress = accounts && accounts[0];
        walletName = "Wallet";
        provider = window.ethereum;
      }

      if (!walletAddress) {
        throw new Error("No wallet account was returned.");
      }
      showResult("Verifying NFT ownership\u2026", "info");

      var resp = await fetch(container.dataset.appProxyUrl + "/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          walletAddress: walletAddress,
          contractAddress: container.dataset.contractAddress,
          productId: container.dataset.productId,
          gateRuleHandle: container.dataset.gateRuleHandle,
        }),
      });

      var data = await resp.json();

      if (data.verified) {
        var verifiedState = await persistVerifiedState(data.gateToken);
        saveWalletSession(walletAddress);
        onVerified(walletAddress, data, verifiedState);
      } else {
        var msg =
          data.error ||
          "No qualifying NFT found for " + shortenAddress(walletAddress);
        showResult(msg, "error");
        resetWalletList();
        updateProductGateState(normalizeVerifiedState({}));
      }
    } catch (err) {
      var message = err && err.message ? err.message : String(err);
      if (err.code === 4001) {
        showResult("Wallet connection cancelled.", "error");
      } else if (
        message.indexOf("defaultChain") !== -1 &&
        provider !== window.ethereum &&
        isUsableProvider(window.ethereum)
      ) {
        try {
          showResult("That wallet failed to initialize. Trying wallet\u2026", "info");
          var browserAccounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          var browserWalletAddress = browserAccounts && browserAccounts[0];
          if (!browserWalletAddress) {
            throw new Error("No wallet account was returned.");
          }

          var fallbackResp = await fetch(container.dataset.appProxyUrl + "/verify", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              walletAddress: browserWalletAddress,
              contractAddress: container.dataset.contractAddress,
              productId: container.dataset.productId,
              gateRuleHandle: container.dataset.gateRuleHandle,
            }),
          });

          var fallbackData = await fallbackResp.json();
          if (fallbackData.verified) {
            var fallbackState = await persistVerifiedState(fallbackData.gateToken);
            saveWalletSession(browserWalletAddress);
            onVerified(browserWalletAddress, fallbackData, fallbackState);
            return;
          }

          showResult(
            fallbackData.error ||
              "No qualifying NFT found for " + shortenAddress(browserWalletAddress),
            "error"
          );
        } catch (fallbackErr) {
          showResult(
            "Wallet connection failed. Try again or refresh the page.",
            "error"
          );
        }
      } else {
        showResult("Error: " + message, "error");
      }
      resetWalletList();
    }
  }

  function onVerified(walletAddress, data, verifiedState) {
    var container = getProductContainer();
    var isExclusive = container && container.dataset.exclusive === "true";
    var discountPct = container ? container.dataset.discountPercentage : "0";

    if (isExclusive) {
      showResult(
        "\u2705 Verified! Welcome, " +
          shortenAddress(walletAddress) +
          ". You can now purchase this product.",
        "success"
      );
    } else {
      showResult(
        "\u2705 Verified! " +
          shortenAddress(walletAddress) +
          " \u2014 your " +
          discountPct +
          "% discount will be applied at checkout.",
        "success"
      );
    }

    updateProductGateState(verifiedState);
  }

  function getCartGuardLines() {
    return Array.prototype.slice.call(
      document.querySelectorAll("[data-token-gate-line]")
    );
  }

  function isLineGated(line) {
    if (!line || line.dataset.gateRuleHandle === "") return false;

    var gatedVariants = parseJSON(line.dataset.gatedVariants, []);
    if (!Array.isArray(gatedVariants) || gatedVariants.length === 0) {
      return true;
    }

    return gatedVariants.indexOf(line.dataset.variantId) !== -1;
  }

  function isLineVerified(line, verifiedState) {
    if (!isLineGated(line)) return true;

    var entry = verifiedState.products[line.dataset.productId];
    if (!entry) return false;
    if (!entry.variantIds || !entry.variantIds.length) return true;

    return entry.variantIds.indexOf(line.dataset.variantId) !== -1;
  }

  function showCartMessage(text, tone) {
    var message = document.getElementById(CART_MESSAGE_ID);
    if (!message) return;

    message.style.display = "block";
    message.textContent = text;
    message.dataset.tone = tone || "warning";
  }

  function hideCheckoutButtons(hidden) {
    getCheckoutButtons().forEach(function (button) {
      if (hidden) {
        button.style.display = "none";
        button.setAttribute("aria-hidden", "true");
      } else {
        button.style.display = "";
        button.removeAttribute("aria-hidden");
      }
    });
  }

  async function removeCartLines(lines) {
    for (var i = 0; i < lines.length; i += 1) {
      var lineKey = lines[i].dataset.lineKey;
      if (!lineKey) continue;

      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      });
    }
  }

  async function runCartGuard() {
    var lines = getCartGuardLines();
    if (!lines.length) return;

    var cart = await fetchCart();
    var verifiedState = normalizeVerifiedState(
      parseJSON((cart.attributes || {})[VERIFIED_ATTRIBUTE], {})
    );

    var invalidLines = lines.filter(function (line) {
      return !isLineVerified(line, verifiedState);
    });

    if (!invalidLines.length) {
      hideCheckoutButtons(false);
      return;
    }

    hideCheckoutButtons(true);
    showCartMessage(
      "Unverified gated items were found in your cart. They are being removed. Re-verify on the product page before adding them again.",
      "warning"
    );

    await removeCartLines(invalidLines);
    window.location.reload();
  }

  function initProductGate() {
    var container = getProductContainer();
    if (!container) return;
    if (container.dataset.tokenGateReact === "true") return;

    var discoveredWallets = [];
    var connectBtn = document.getElementById("token-gate-connect-btn");
    var walletListEl = document.getElementById("token-gate-wallet-list");

    window.addEventListener("eip6963:announceProvider", function (event) {
      var detail = event.detail;
      if (!detail || !detail.provider) return;

      var isDuplicate = discoveredWallets.some(function (wallet) {
        return (
          (wallet.info && detail.info && wallet.info.uuid === detail.info.uuid) ||
          wallet.provider === detail.provider
        );
      });

      if (isDuplicate) return;

      discoveredWallets.push(detail);
    });

    window.dispatchEvent(new Event("eip6963:requestProvider"));

    if (walletListEl) {
      walletListEl.innerHTML = "";
      walletListEl.style.display = "none";
    }
    if (connectBtn) {
      connectBtn.textContent = "Connect Wallet";
      connectBtn.addEventListener("click", function () {
        var providers = getAvailableProviders(discoveredWallets);
        if (!providers.length) {
          showResult(
            "No wallet detected. Install a Web3 wallet extension to continue.",
            "error"
          );
          return;
        }

        connectWithProvider(providers[0].provider, providers[0].name);
      });
    }

    setTimeout(function () {
      if (getAvailableProviders(discoveredWallets).length === 0) {
        showResult(
          "No wallet detected. Install a Web3 wallet extension to continue.",
          "error"
        );
        if (connectBtn) connectBtn.style.display = "none";
      }
    }, 500);

    setTimeout(function () {
      maybeRestoreWalletSession(discoveredWallets);
    }, 900);

    var select = document.getElementById("variant-select");
    var refreshState = function () {
      fetchCart()
        .then(function (cart) {
          var verifiedState = normalizeVerifiedState(
            parseJSON((cart.attributes || {})[VERIFIED_ATTRIBUTE], {})
          );
          updateProductGateState(verifiedState);
        })
        .catch(function () {
          updateProductGateState(normalizeVerifiedState({}));
        });
    };

    refreshState();

    if (select) {
      select.addEventListener("change", function () {
        refreshState();
        setTimeout(function () {
          maybeRestoreWalletSession(discoveredWallets);
        }, 50);
      });
    }
  }

  async function maybeRestoreWalletSession(discoveredWallets) {
    var container = getProductContainer();
    if (!container || !isCurrentSelectionGated(container)) return;

    var stored = getStoredWalletSession();
    if (!stored || !stored.walletAddress) return;

    var cart = await fetchCart();
    var verifiedState = normalizeVerifiedState(
      parseJSON((cart.attributes || {})[VERIFIED_ATTRIBUTE], {})
    );

    if (isSelectionVerified(verifiedState, container)) {
      return;
    }

    var providers = getAvailableProviders(discoveredWallets);
    for (var i = 0; i < providers.length; i += 1) {
      try {
        var accounts = await providers[i].provider.request({ method: "eth_accounts" });
        var walletAddress = accounts && accounts[0];
        if (!walletAddress) continue;
        if (String(walletAddress).toLowerCase() !== stored.walletAddress) continue;

        showResult("Restoring wallet session\u2026", "info");

        var resp = await fetch(container.dataset.appProxyUrl + "/verify", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            walletAddress: walletAddress,
            contractAddress: container.dataset.contractAddress,
            productId: container.dataset.productId,
            gateRuleHandle: container.dataset.gateRuleHandle,
          }),
        });

        var data = await resp.json();
        if (!data.verified) return;

        var restoredState = await persistVerifiedState(data.gateToken);
        onVerified(walletAddress, data, restoredState);
        return;
      } catch (_err) {
        // Try the next provider silently.
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initProductGate();
    runCartGuard().catch(function (err) {
      console.error("Token gate cart guard failed:", err);
      hideCheckoutButtons(true);
      showCartMessage(
        "We couldn't verify gated items in your cart. Please return to the product page and verify your wallet again.",
        "error"
      );
    });
  });
})();
